import { html, render } from 'lit-html'
import User from '@polleverywhere/core/lib/models/user'
import { normalizeXhrError } from '@polleverywhere/core/lib/util'
import { bemBlock } from '@polleverywhere/bem-helpers'

import '@polleverywhere/text-field'

import './style.scss'

function validate (textField) {
  textField.validate()
  if (!textField.valid) {
    textField.setAttribute('error', 'Presenter not found')
    return false
  }
  return true
}

export default class Join extends Backbone.View {
  get className () { return 'pollev-home__join' }

  initialize () {
    this.bem = bemBlock(this.className)
  }

  render () {
    render(html`
      <form action='#' class='${this.bem('form')}' method='POST' novalidate @submit=${this.handleSubmit}>
        <h1 class=${this.bem('header')}>
          <label for='join-a-presentation'>Join presentation</label>
        </h1>
        <text-field
          class='${this.bem('input')}'
          id='join-a-presentation'
          aria-describedby='aria-join-username'
          type=text
          required
          pattern='[A-Za-z0-9]{3,}'
          placeholder='username'
          autocapitalize=off autocorrect=off spellcheck=false
          use-default-placeholder
        >
          <div slot='before' class='${this.bem('presenter-prefix')}' role='presentation' @click=${() => this.textField.focus()}>PollEv.com/</div>
        </text-field>
        <button class='${this.bem('submit')}' type='submit'>Join</button>
        <div hidden id='aria-join-username'>Enter the presenter's username to join their presentation</div>
      </form>
    `, this.el, {
      eventContext: this
    })

    this.textField = this.el.querySelector(`.${this.bem('input')}`)
    this.submitButton = this.el.querySelector(`.${this.bem('submit')}`)

    return this
  }

  handleSubmit (e) {
    e.preventDefault()

    if (validate(this.textField)) {
      this.joinPresentation(this.textField.value)
    }
  }

  joinPresentation (username) {
    username = username.trim()

    User
      .check(username)
      .then((data) => {
        if (!data.exists) {
          this.textField.setAttribute('error', 'Presenter not found')
        }
        this.trigger('join', username, !!data.exists)
      })
      .catch((xhr) => {
        const error = normalizeXhrError(xhr)
        this.textField.setAttribute('error', error.message)
      })
  }
}
